import { WorkRequirementCaseNumbersScreen } from "@/interactors/WorkRequirementCaseNumbersScreen";

export default function WorkRequirementCaseNumbers() {
  return <WorkRequirementCaseNumbersScreen />;
}
